const release = '0.12.0'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js